export default __webpack_public_path__ + "static/media/logo_white.82686256.png";